import mapResponseToProvenance from '../mappers/mapResponseToWidget'

export default async function(
  response: Response,
  response2: Response = undefined,
) {
  let json = await response.json()

  let json2 = undefined
  if (response2) {
    json2 = await response2.json()
  }

  return mapResponseToProvenance(
    json,
    json2,
    (response2 && response2.status === 409) ||
      (response && response.status === 409),
  )
}
